import { Event, NavigationEnd, Router } from '@angular/router';
import $ from 'jquery';

/** Subset of AppComponent state mutated by global router side effects. */
export interface AppRouterEventsHost {
  activepricing: boolean;
  loginPage: boolean;
  brokerpage: boolean;
  brokerexist: boolean;
  whname: unknown;
  PicName: unknown;
  support_email: string;
  support_phone: unknown;
  router: Router;
  updateNavActiveState(): void;
}

function applyBrokerPicName(host: AppRouterEventsHost, username: string): void {
  const Username_Space_Split = username.split(' ');
  const Username_Hyphen_Split = username.split('-');
  if (Username_Space_Split.length > 1) {
    host.PicName =
      username.split(' ')[0].substring(0, 1) + '' + username.split(' ')[1].substring(0, 1);
  } else if (Username_Hyphen_Split.length > 1) {
    host.PicName =
      username.split('-')[0].substring(0, 1) + '' + username.split('-')[1].substring(0, 1);
  } else {
    host.PicName = username.substring(0, 1);
  }
}

function hydrateBrokerSession(host: AppRouterEventsHost, delayMs = 600): void {
  setTimeout(() => {
    const whname = JSON.parse(window.localStorage.getItem('brokerdetail')!);
    host.whname = whname.brokerDetails[0].name;
    const brokerDetail = JSON.parse(window.localStorage.getItem('brokerdetail')!);
    if (brokerDetail.wholesalerUserDetails[0].support.length !== 0) {
      host.support_email = brokerDetail.wholesalerUserDetails[0].support[0].userEmail;
      host.support_phone = brokerDetail.wholesalerUserDetails[0].support[0].phoneNumber;
    }
    $('body').addClass('broker-pages');
    applyBrokerPicName(host, host.whname as string);
  }, delayMs);
}

/** Central router.events handler extracted from AppComponent (runbook P2 split). */
export function handleAppRouterNavigationEvent(event: Event, host: AppRouterEventsHost): void {
  $('.fnewss').hide();
  $('#newsvalidator').hide();
  $('.newsLetter').removeAttr('style');
  host.activepricing = window.location.href.indexOf('Pharmacy') > -1;

  if (!(event instanceof NavigationEnd)) {
    return;
  }

  if (event.url == '/cards/TracFone-GlicRx-Card.pdf') {
    $('.mobileheader_download').hide();
  }
  host.updateNavActiveState();

  if (event.url.includes('brokerportal')) {
    if (event.url.lastIndexOf('/') != 0) {
      const lastcode = event.url.split('/').pop();
      host.router.navigate(['/enrollmentcenter/' + lastcode]);
    } else {
      host.router.navigate(['/enrollmentcenter']);
    }
  }

  if (event.url.lastIndexOf('/') != 0) {
    host.loginPage = false;
    $('body').addClass('loginPage');
    if (window.localStorage.getItem('brokerdetail')) {
      const b = new Date();
      localStorage.b = b;
      const differenceDate =
        Math.abs(Date.parse(localStorage.b) - Date.parse(localStorage.a)) / 36e5 * 60;
      if (differenceDate > 720) {
        window.localStorage.removeItem('brokerdetail');
      } else {
        host.router.navigate(['/enrollmentcenter']);
      }
      setTimeout(() => {
        const whname = JSON.parse(window.localStorage.getItem('brokerdetail')!);
        host.whname = whname.brokerDetails[0].name;
      }, 600);
    }
  }

  if (event.url.lastIndexOf('/') == 0 && event.url == '/guidebook-and-resources') {
    if (window.location === window.parent.location) {
      if (window.localStorage.getItem('brokerdetail')) {
        host.brokerpage = true;
        host.loginPage = false;
        host.brokerexist = true;
        hydrateBrokerSession(host);
      } else {
        host.router.navigate(['/']);
      }
    }
  }

  if (event.url.lastIndexOf('/') == 0 && event.url == '/enrollmentcenter') {
    if (window.localStorage.getItem('brokerdetail')) {
      host.brokerpage = true;
      host.loginPage = false;
      host.brokerexist = true;
      hydrateBrokerSession(host);
    } else {
      host.router.navigate(['/']);
    }
  }

  if (event.url.lastIndexOf('/') == 0 && event.url == '/Pharmacy') {
    if (window.localStorage.getItem('brokerdetail')) {
      if (host.brokerexist == true) {
        host.brokerpage = true;
        host.loginPage = false;
        host.brokerexist = true;
        setTimeout(() => {
          const whname = JSON.parse(window.localStorage.getItem('brokerdetail')!);
          host.whname = whname.brokerDetails[0].name;
          $('body').addClass('broker-pages');
          applyBrokerPicName(host, host.whname as string);
        }, 600);
      } else {
        host.brokerpage = false;
        host.loginPage = true;
        host.brokerexist = false;
      }
    }
  }

  if (event.url.lastIndexOf('/') == 0 && event.url == '/contact#faq') {
    if (window.localStorage.getItem('brokerdetail')) {
      if (host.brokerexist == true) {
        host.brokerpage = true;
        host.loginPage = false;
        host.brokerexist = true;
        setTimeout(() => {
          const whname = JSON.parse(window.localStorage.getItem('brokerdetail')!);
          host.whname = whname.brokerDetails[0].name;
          $('body').addClass('broker-pages');
          applyBrokerPicName(host, host.whname as string);
        }, 600);
      } else {
        host.brokerpage = false;
        host.loginPage = true;
        host.brokerexist = false;
      }
    }
  }

  if (event.url.includes('printmycard')) {
    $('.header-section').hide();
    $('.footer-section').hide();
  }
  if (event.url.includes('recoverAccessCode')) {
    $('.loginh').hide();
    $('.footer-section').hide();
  }
}
